import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const AudioPlayerWrapper = styled('div')`
  display: flex;
  flex-direction: row;

  /* override player css */
  .rhap_container {
    background: none !important;
    box-shadow: none !important;
    width: 'inherit' !important;
    flex: 1 !important;
    padding-right: 0 !important;
  }

  .rhap_time {
    font-size: ${theme.font.size.copy} !important;
  }

  .rhap_progress-bar {
    background-color: ${theme.color.designSystem.blackOpacity12};
    border-radius: ${theme.borderRadius.medium};
    height: 4px;
  }

  .rhap_download-progress {
    background-color: transparent;
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid transparent;
  }

  .rhap_progress-filled {
    background-color: ${theme.color.designSystem.purple50};
    border-radius: ${theme.borderRadius.medium};
  }

  .rhap_progress-indicator {
    background: ${theme.color.designSystem.purple70};
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14),
      0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
    width: 16px;
    height: 16px;
    top: -6px;
  }

  .rhap_controls-section {
    display: none;
  }
`;

export const AudioPlayerButton = styled.button`
  background: ${theme.color.designSystem.purple70};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  color: ${theme.color.white};
  height: 40px;
  width: 40px;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
`;

export const AudioPlayerButtonIcon = styled.span`
  display: flex;
  svg {
    height: 14px;
  }
`;
